module.exports = __webpack_public_path__ + "officialStatic/img/productB32.f1015cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB32.png
// module id = FzZR
// module chunks = 0